<template>
  <div>
    <div class="item" v-tap="{methods:toggleReason}">
      <span class="check" :class="{checked: student.checked}" v-tap="{methods:checkIn,normal:0}"></span>
      <span class="name" v-text="student.userName"></span>
      <span class="course" :class="{warning: student.isArrears}">已上{{student.aboveCourse}}节/共{{student.totalCourse}}节</span>
      <span class="right-arrow"></span>
    </div>

    <div class="reason" v-show="student.visible">
      <div class="right">
          <!-- <router-link to="/UpImage"> -->
            <!-- <span class="upImage" @click="upImage(position)">(已上传{{userImage}}张)上传学生照片></span> -->
          <!-- </router-link> -->
      </div>
      <div class="radio-list-wrapper">
        <label class="radio-title">缺勤原因</label>
        <ul>
          <!-- v-tap="{methods:itemChecked,index:index}" -->
          <li v-for="item,index in reasons" :key="index" @click="itemChecked({index})">
            <input type="radio" class="radio-input" :value="item.dictValue" v-model="chooseReason" disabled>
            <span :class="item.dictValue===student.dictCodeId ? 'selected':'radio-core'"></span>
            <!-- <input v-if="index == reasons.length-1" type="text" class="radio-text" v-model="chooseReason1"
                   placeholder="输入其他原因" @input="handleInputChanged"> -->
            <span  class="radio-label">{{item.dictLabel}}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui';
  import Teacher from '../api/teacher';
  import { mapGetters } from 'vuex';
  export default{
    name: 'check-in-item',
    props: {
      student: {
        type: Object
      },
      reasons:{
        type: Array
      },
      position:{
        type: Number
      },
      userImage:{
        type:Number,
        default:0
      }
    },
    data() {
      return {
        aaa: '',
        index: 100,
        isColor:false,
        // visible:false,
        // checked:false,
        // dictCodeId:''
      };
    },
    methods: {
      //单机选择出勤大按钮时，判断当前学生是否有课时数量
      checkIn (params) {
        //清楚选中缺勤小按钮，如果选中了缺勤状态则不能选中大按钮
        this.student.dictCodeId=''

        params.event.stopPropagation();
        if (this.student.isArrears) {
          Toast({message: '该学生已经没有课时了', position: 'middle', duration: 1500});
          return;
        }
        //如果没有课时了，为false 给父组件传递当前学生id，false参数来改变当前订单不要进行签到
        this.student.checked = !this.student.checked;
        if(this.student.checked){
          this.$emit('itemChecked',params.normal,this.position);
        }else{
          this.$emit('itemChecked','',this.position);
        }
      },
      //展示下拉框
      toggleReason () {
        if(this.student.isArrears){
          // this.visible=false;
          this.student.visible=false;
          // this.$emit('IsVisible',this.position,this.student);
          Toast({message: '该学生已经没有课时了', position: 'middle', duration: 1500});
        }else{
          this.student.visible = !this.student.visible;
          // this.visible= !this.visible;
          // this.$emit('IsVisible',this.position,this.student);
        }
      },
      //获取点击li的index
      itemChecked({index}) {
        this.student.dictCodeId = this.reasons[index].dictValue;
        this.index = index;
        this.student.checked = false;
        this.$emit('itemChecked',this.chooseReason.dictValue,this.position);
      },
      //路由跳转到图片上传页面
      upImage(position){
        //存储当前点击学生数据的数组索引
        this.$store.commit('studentId',position)
        //存储全部学生信息，用来存储添加上传的图片userImage，用作回显
        this.$store.commit('studentList',this.student)
        this.$router.push({
          
          path: '/UpImage',
        })
      }
    },
    computed: {
      //返回现有选项值
      chooseReason() {
        return this.reasons[this.index];
      },
      //计算缺勤状态
      // getReason() {
      //   let reason = '';
      //   //把输入框的值赋给reason当作原因 否则是现有原因
      //   // if (this.index === this.reasons.length - 1) {
      //   //   reason = this.chooseReason1;
      //   // } else {
      //     reason = this.reasons[this.index];
      //   // }
      //   return reason;
      // }
    },
    components: {Toast},
    watch:{
      "student":{
        handler(newVal,oldVal){
          // console.log(newVal,"****",oldVal)
        }
      }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import "../assets/scss/base.scss";

  .item {
    height: px2rem(65);
    display: flex;
    flex-direction: row;
    padding: 0 px2rem(22);
    span {
      color: white;
      font-size: px2rem(25);
      height: px2rem(65);
      overflow: hidden;
      line-height: px2rem(65);
      vertical-align: middle;
      display: inline-block;

      &.name {
        margin-left: px2rem(16);
      }

      &.course {
        margin-left: px2rem(16);
        flex: 1;
      }

      &.warning {
        color: #ff2e0f
      }

      &.right-arrow {
        margin-top: px2rem(15);
        height: px2rem(36);
        line-height: px2rem(60);
        width: px2rem(43);
        @include bg-img('../assets/img/teacher/right_arrow');
      }
    }
  }

  .reason {
    font-size: px2rem(20);
    color: white;
    .right{
          display: flex;
          justify-content: right;
          .upImage{
            margin: px2rem(10) px2rem(10) 0 0;
            font-weight: bolder;
            font-size: px2rem(25);
          }
        }
    .radio-list-wrapper {
      padding: 0 5%;
      .radio-title {
        display: inline-block;
        font-size: px2rem(24);
        color: white;
        margin: px2rem(8);
      }

      ul {
        li {
          height: px2rem(60);
          font-size: px2rem(28);
          padding: 0 px2rem(10);

          .radio-input {
            display: none;
            // &:checked + .radio-core {
            //   background-color: #7cc859;
            //   border-color: #7cc859;
            // }
            // &:checked + .radio-core:after {
            //   background-color: #fff;
            //   transform: scale(1);
            // }
          }
          .selected {
            box-sizing: border-box;
            display: inline-block;
            background-color: #7cc859;
            border-radius: 100%;
            border: px2rem(1) solid #7cc859;
            position: relative;
            vertical-align: middle;
            width: px2rem(40);
            height: px2rem(40);

            &:after {
              content: " ";
              border-radius: 100%;
              top: px2rem(10);
              left: px2rem(10);
              position: absolute;
              width: px2rem(16);
              height: px2rem(16);
              transition: -webkit-transform .2s;
              transform: scale(0);
            }
          }
          .radio-core {
            box-sizing: border-box;
            display: inline-block;
            background-color: #fff;
            border-radius: 100%;
            border: px2rem(1) solid #ccc;
            position: relative;
            vertical-align: middle;
            width: px2rem(40);
            height: px2rem(40);

            &:after {
              content: " ";
              border-radius: 100%;
              top: px2rem(10);
              left: px2rem(10);
              position: absolute;
              width: px2rem(16);
              height: px2rem(16);
              transition: -webkit-transform .2s;
              transform: scale(0);
            }
          }

          .radio-label {
            margin-left: px2rem(12);
          }

          .radio-text {
            appearance: none;
            height: px2rem(40);
            margin: px2rem(10) 0 px2rem(10) px2rem(16);
            padding-left: px2rem(10);
            border-radius: px2rem(5);
            font-size: px2rem(25);
            color: #666;
            &:focus {
              outline: 0;
            }
          }
        }
      }

    }
    span {
      color: white;
      font-size: px2rem(25);
      height: px2rem(60);
      overflow: hidden;
      line-height: px2rem(60);
      vertical-align: middle;
      display: inline-block;
    }

    &:before {
      display: block;
      content: '';

      border-top: px2rem(1) solid #a37943;
      width: 90%;
      margin: px2rem(10) auto 0 auto;
    }

    .radio-list {
      padding: 0 px2rem(50);
    }

  }

  .check {
    margin-top: px2rem(1);
    height: px2rem(60);
    line-height: px2rem(60);
    width: px2rem(60);
    @include bg-img('../assets/img/teacher/unchecked');
    &.checked {
      @include bg-img('../assets/img/teacher/checked');
    }
  }


</style>



// WEBPACK FOOTER //
// CheckInItem.vue?bb647bc8